// Multi-language UI translations
export const LANGUAGES = [
  { code: "ar", name: "العربية", rtl: true },
  { code: "ckb", name: "کوردی سۆرانی", rtl: true },
  { code: "kmr", name: "کوردی بادینی", rtl: true },
  { code: "en", name: "English", rtl: false },
  { code: "fr", name: "Français", rtl: false },
  { code: "es", name: "Español", rtl: false },
  { code: "de", name: "Deutsch", rtl: false },
  { code: "tr", name: "Türkçe", rtl: false },
  { code: "it", name: "Italiano", rtl: false },
  { code: "pt", name: "Português", rtl: false },
  { code: "ru", name: "Русский", rtl: false },
  { code: "zh", name: "中文", rtl: false },
  { code: "ja", name: "日本語", rtl: false },
  { code: "ko", name: "한국어", rtl: false },
  { code: "hi", name: "हिन्दी", rtl: false },
  { code: "ur", name: "اردو", rtl: true },
  { code: "fa", name: "فارسی", rtl: true },
  { code: "id", name: "Indonesia", rtl: false },
];

export const isRTL = (code) => LANGUAGES.find(l => l.code === code)?.rtl || false;

const T = {
  ar: {
    app_name: "حياتك",
    tagline_part1: "صديقك في كل لحظة من",
    tagline_part2: "حياتك",
    hero_desc: "رفيق ذكي يسمعك بصدق، يساندك في أحزانك، يفرح معك في أفراحك، ويساعدك في تنظيم يومك ومشاريعك. يحفظ خصوصيتك ويحمل الاسم الذي تختاره أنت.",
    cta_start: "ابدأ رحلتك مجاناً",
    cta_have_account: "عندي حساب",
    nav_login: "دخول",
    nav_register: "سجّل الآن",
    feat_chat: "محادثة", feat_journal: "يومياتك", feat_mood: "مزاجك",
    feat_goals: "أهدافك", feat_affirm: "تحفيز يومي", feat_private: "خاص بك",
    safety_title: "خصوصيتك وسلامتك أولاً",
    safety_desc: "معلوماتك محمية بالكامل ولا تُشارك مع أحد. الرفيق يدعمك بكل احترام، ذكراً كنت أو أنثى، ولا يقدّم أي محتوى يدعم العنف أو يضرّك أو يضرّ غيرك.",
    companion_says: "صديقك يقول:",
    sample_msg: "مرحباً 💛 أنا هنا لأجلك في كل لحظة. مهما كان شعورك اليوم — فرحاً أو ضيقاً — حدّثني، أنا أصغي.",
    sample_reply: "شكراً، أحس بأنني لست وحيداً 🌿",
    welcome_back: "مرحباً بعودتك 🌿",
    login_sub: "سجّل دخولك لتجد رفيقك بانتظارك",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    login: "دخول",
    or: "أو",
    facebook: "فيسبوك",
    twitter: "تويتر / X",
    google: "جوجل",
    social_soon: "تسجيل الدخول الاجتماعي قادم قريباً 💛",
    auth_finalizing: "جارٍ تسجيل دخولك...",
    auth_one_moment: "لحظات ونصلك إلى مساحتك الشخصية",
    auth_social_error: "تعذّر تسجيل الدخول الاجتماعي. حاول مرة أخرى.",
    admin_panel: "الإدارة",
    login_with_google: "تسجيل الدخول عبر جوجل",
    no_account: "لا تملك حساباً؟",
    create_account: "أنشئ حسابك",
    forgot_password: "نسيت كلمة المرور؟",
    start_journey: "ابدأ رحلتك ✨",
    register_sub: "حسابك خاص بك. معلوماتك مشفّرة ولا تُشارك مع أحد.",
    your_name: "اسمك",
    your_email: "بريدك الإلكتروني",
    your_password: "كلمة المرور (٦ أحرف على الأقل)",
    your_age: "عمرك",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    other: "أفضل عدم التحديد",
    your_country: "بلدك (اختياري)",
    your_interests: "اهتماماتك / هواياتك (اختياري)",
    companion_label: "اسم رفيقك الذكي (مثل: نور)",
    preferred_language: "اللغة المفضلة",
    privacy_note: "🔒 خصوصيتك محفوظة: معلوماتك لا تُشارك مع أحد، وتُستخدم فقط لجعل رفيقك يفهمك أكثر.",
    safety_note: "🛡️ التطبيق يدعم سلامتك دائماً ولا يقدّم أي محتوى يضرّك أو يضرّ غيرك.",
    create_my_account: "أنشئ حسابي",
    have_account: "تملك حساباً؟",
    sign_in: "سجّل دخولك",
    reset_title: "استعادة كلمة المرور 🔐",
    reset_sub: "أدخل بريدك للحصول على رمز استعادة.",
    send_reset: "أرسل رمز الاستعادة",
    back_to_login: "العودة لتسجيل الدخول",
    reset_token_label: "رمز الاستعادة (انسخه):",
    proceed_reset: "متابعة لإعادة التعيين",
    reset_new_title: "إعادة تعيين كلمة المرور",
    reset_new_sub: "أدخل رمز الاستعادة وكلمة المرور الجديدة.",
    reset_token_input: "رمز الاستعادة",
    new_password: "كلمة المرور الجديدة (٦ أحرف+)",
    confirm_password: "تأكيد كلمة المرور",
    update_password: "حدّث كلمة المرور",
    passwords_dont_match: "كلمتا المرور غير متطابقتين",
    hello: "أهلاً بك يا",
    logout: "خروج",
    your_companion: "رفيقك",
    personal_companion: "رفيقك الشخصي",
    tab_chat: "محادثة", tab_journal: "يومياتي", tab_mood: "مزاجي",
    tab_goals: "أهدافي", tab_weekly: "تحليلي الأسبوعي",
    tab_health: "صحتي",
    tab_appointments: "مواعيدي",
    mood_happy: "سعيد", mood_neutral: "عادي", mood_sad: "حزين",
    mood_stressed: "متوتر", mood_motivated: "متحمس",
    chat_placeholder: "حدّث رفيقك...",
    send: "إرسال",
    clear: "مسح",
    confirm_clear: "هل تريد مسح كل المحادثة؟",
    start_chat: "ابدأ محادثتك مع رفيقك... شاركه ما تشعر به الآن 💛",
    error_retry: "حدث خطأ، حاول مرة أخرى.",
    attach_image: "إرفاق صورة",
    take_photo: "التقاط بالكاميرا",
    remove_image: "إزالة الصورة",
    image_caption_placeholder: "اكتب سؤالك عن الصورة... (اختياري)",
    image_too_large: "الصورة كبيرة جداً (الحد الأقصى 8 ميغابايت)",
    image_only: "يرجى اختيار ملف صورة فقط",
    record_voice: "تسجيل صوتي",
    stop_recording: "إيقاف التسجيل",
    recording: "جاري التسجيل...",
    transcribing: "جاري تحويل الصوت إلى نص...",
    voice_not_supported: "متصفحك لا يدعم التسجيل الصوتي",
    voice_permission_denied: "يرجى السماح بالوصول إلى الميكروفون",
    play_aloud: "استماع",
    stop_playback: "إيقاف",
    voice_settings: "إعدادات الصوت",
    voice_pick: "اختر الصوت",
    voice_speed: "السرعة",
    attach_pdf: "إرفاق PDF",
    pdf_only: "يرجى اختيار ملف PDF فقط",
    journal_title_label: "دفتر يومياتك",
    journal_title_input: "عنوان (اختياري)",
    journal_content_input: "اكتب ما يدور في خاطرك...",
    add_to_journal: "أضف لليوميات",
    no_journal_yet: "لم تكتب شيئاً بعد. ابدأ يومياتك الآن 🌸",
    untitled: "بدون عنوان",
    log_mood_title: "سجّل مزاجك",
    mood_note_input: "ملاحظة سريعة (اختياري)",
    log: "سجّل",
    stats_label: "إحصائياتك",
    entries: "تسجيل",
    last_logs: "آخر التسجيلات",
    goals_title: "أهدافك ومشاريعك",
    goal_title_input: "عنوان الهدف",
    goal_desc_input: "وصف مختصر (اختياري)",
    add_goal: "أضف هدفاً",
    no_goals: "أضف هدفك الأول 🎯 سيكون رفيقك معك في كل خطوة.",
    weekly_title: "تحليلي الأسبوعي",
    weekly_loading: "جاري تحضير تحليلك...",
    weekly_top_mood: "المزاج الغالب",
    weekly_journal_count: "يوميات",
    weekly_goals_completed: "أهداف منجزة",
    weekly_chat_count: "رسائل محادثة",
    weekly_active_goals: "أهداف نشطة",
    weekly_refresh: "تحديث",
    tab_memories: "ذاكرة الرفيق",
    memories_title: "ما يتذكره رفيقك عنك",
    memories_empty: "لا يوجد ذكريات بعد. تحدّث مع رفيقك أكثر وسيبدأ بتذكّر تفاصيل عنك تلقائياً 🧠",
    memories_intro: "هذه الحقائق يستخرجها رفيقك تلقائياً من محادثاتكما ليتذكّرك دائماً. يمكنك حذف أي منها أو الكل.",
    clear_all_memories: "مسح كل الذكريات",
    confirm_clear_memories: "هل تريد مسح كل ذكريات الرفيق عنك؟",
    tab_insights: "رؤى عنك",
    insights_title: "رؤى رفيقك عنك",
    insights_intro: "تحليل ذكي لأنماطك خلال ٣٠ يوماً، يكشف ما يلاحظه رفيقك عنك.",
    insights_loading: "رفيقك يفكر فيك...",
    insights_themes: "ما يلاحظه عنك",
    insights_refresh: "تحديث الرؤى",
    starters_label: "اقتراحات للحديث",
    starters_refresh: "اقتراحات جديدة",
    web_search_used: "بحث على الإنترنت",
    tab_images: "صور",
    tab_pdf: "ملفات PDF",
    tab_voice: "محادثة صوتية",
    download: "تحميل",
    confirm_delete: "هل تريد الحذف؟",
    // Images
    images_title: "صور بالذكاء الاصطناعي",
    images_subtitle: "أنشئ صوراً جديدة أو عدّل صوراً موجودة",
    img_mode_generate: "إنشاء من نص",
    img_mode_edit: "تعديل صورة",
    img_upload_label: "صورة الإدخال",
    img_choose_file: "اختر صورة",
    img_prompt_label: "وصف الصورة",
    img_prompt_gen_ph: "مثال: حديقة هادئة عند شروق الشمس مع أزهار الكرز، أسلوب مائي…",
    img_prompt_edit_ph: "مثال: غيّر الخلفية إلى البحر عند الغروب، احتفظ بالشخصية كما هي…",
    img_btn_generate: "أنشئ الصورة",
    img_btn_edit: "عدّل الصورة",
    img_working: "جارٍ المعالجة…",
    img_prompt_required: "اكتب وصفاً للصورة أولاً",
    img_file_required: "اختر صورة لتعديلها",
    img_too_big: "الصورة كبيرة جداً (حد 8 ميغابايت)",
    img_history: "صورك السابقة",
    // PDF
    pdf_title: "تحليل ملفات PDF",
    pdf_subtitle: "ارفع ملف PDF واسأل الذكاء الاصطناعي ما تشاء عنه",
    pdf_upload_label: "ملف PDF",
    pdf_choose_file: "اختر ملف PDF",
    pdf_question_label: "سؤالك",
    pdf_question_ph: "مثال: لخّص الملف بنقاط، أو ما هي أهم الأرقام؟ (اتركه فارغاً للتلخيص العام)",
    pdf_analyze_btn: "حلّل الملف",
    pdf_working: "جارٍ القراءة والتحليل…",
    pdf_file_required: "ارفع ملف PDF أولاً",
    pdf_too_big: "الملف كبير جداً (حد 15 ميغابايت)",
    pdf_pages: "صفحة",
    pdf_truncated: "⚠️ تم قص الملف لطوله؛ الردّ مبني على الجزء الذي قُرئ.",
    pdf_answer_label: "التحليل",
    pdf_history: "تحليلاتك السابقة",
    // About section
    about_kicker: "لماذا «حياتك»؟",
    about_title: "حول التطبيق",
    about_intro: "تطبيق «حياتك» ليس مجرد دردشة ذكاء اصطناعي — إنه منظومة متكاملة تعتني بمشاعرك ووقتك وذكرياتك وأهدافك، مبنية على أقوى نماذج الذكاء الاصطناعي في العالم، ومحمية بأعلى معايير التشفير العالمية.",
    // Goals
    about_goals_title: "إلى ماذا يهدف التطبيق؟",
    about_goals_desc: "نريد أن نقدّم لك رفيقاً رقمياً يفهمك بعمق، يدعمك في كل لحظة، يحفظ خصوصيتك، وينظّم حياتك — دون أن تشعر بأنك أمام تطبيق بارد. هذا هو الهدف الذي بُني التطبيق من أجله.",
    about_goal_companion_title: "رفيق دائم",
    about_goal_companion_desc: "يستمع لك في الفرح والحزن، ويتذكر ما يهمك ليشعرك بأنك مفهوم تماماً.",
    about_goal_organize_title: "تنظيم حياتك",
    about_goal_organize_desc: "أهداف، يوميات، تتبع مزاج، تحليل أسبوعي — كلها في مكان واحد.",
    about_goal_growth_title: "نموّ شخصي حقيقي",
    about_goal_growth_desc: "رؤى ذكية شهرية تكشف لك أنماطك، ومحفّزات يومية تساعدك على التقدّم.",
    about_goal_languages_title: "بكل لغاتك",
    about_goal_languages_desc: "16 لغة مدعومة، الذكاء يردّ بلغتك تلقائياً، والواجهة بالعربية أو الإنجليزية.",
    // Security
    about_security_title: "أنظمة الحماية والتشفير",
    about_security_desc: "بياناتك ملكك أنت، ولا أحد سواك يصل إليها. نستخدم نفس معايير الحماية المعتمدة في البنوك العالمية.",
    about_sec_aes_title: "تشفير AES-256 + HTTPS/TLS 1.3",
    about_sec_aes_desc: "كل بياناتك في قاعدة البيانات محمية بتشفير من فئة عسكرية، وكل اتصال بينك والخادم مشفر.",
    about_sec_jwt_title: "مصادقة JWT + Bcrypt",
    about_sec_jwt_desc: "كلمات المرور تُخزن بـ Bcrypt (لا يمكن فك تشفيرها)، والجلسات محمية بتوكنات JWT مع انتهاء صلاحية تلقائي.",
    about_sec_isolation_title: "عزل تام لبيانات كل مستخدم",
    about_sec_isolation_desc: "محادثاتك، يومياتك، صورك، ملفاتك — جميعها معزولة على مستوى قاعدة البيانات، لا يراها أحد سواك.",
    about_sec_privacy_title: "خصوصية مطلقة",
    about_sec_privacy_desc: "لا نبيع بياناتك، لا نشاركها مع أي طرف ثالث، ولا نستخدمها لتدريب أي نموذج. ملكك بالكامل.",
    // Engines
    about_engines_title: "أنظمة الذكاء الاصطناعي الداعمة",
    about_engines_desc: "خلف الكواليس، يعمل التطبيق على نخبة من أقوى موديلات الذكاء الاصطناعي في العالم — كل واحد منها مختار للمهمة التي يبدع فيها.",
    about_eng_claude_title: "Claude Sonnet 4.5 (Anthropic)",
    about_eng_claude_desc: "محرّك المحادثة الرئيسي — يفهم مشاعرك، يتذكر تفاصيلك، ويردّ بدفء وذكاء عميق.",
    about_eng_gpt_title: "ChatGPT GPT-5.1 (OpenAI)",
    about_eng_gpt_desc: "محلّل ملفات PDF — يقرأ مستنداتك ويلخصها أو يجيب أسئلتك عنها بدقة عالية.",
    about_eng_gemini_title: "Gemini Nano Banana (Google)",
    about_eng_gemini_desc: "محرّك توليد وتعديل الصور — أنشئ صوراً جديدة أو عدّل صوركأي طريقة تريد.",
    about_eng_search_title: "بحث ويب + YouTube مباشر",
    about_eng_search_desc: "يبحث الذكاء تلقائياً على الإنترنت ويوتيوب لإجابتك بأحدث المعلومات والروابط.",
    about_eng_memory_title: "ذاكرة طويلة المدى",
    about_eng_memory_desc: "نظام استخراج ذكي يبني ملفك الشخصي مع كل محادثة، فيتذكّر رفيقك أصغر التفاصيل عنك.",
    about_eng_insights_title: "محلل أنماط ذكي",
    about_eng_insights_desc: "يحلل بياناتك أسبوعياً ويستخرج رؤى عن مزاجك، تركيزك، تقدّمك في أهدافك.",
    // Replaces
    about_replaces_title: "يغنيك عن عشرات التطبيقات",
    about_replaces_desc: "بدل أن تشترك في تطبيق ليوميات، وآخر للمزاج، وثالث لمحرر صور، ورابع لمحادثة AI… التطبيق يجمعها كلها في تجربة واحدة سلسة.",
    about_rep_journal: "تطبيقات اليوميات",
    about_rep_mood: "متتبعات المزاج",
    about_rep_planner: "منظّمات المهام والأهداف",
    about_rep_chatbot: "روبوتات الدردشة AI",
    about_rep_imgedit: "محرّرات الصور بالذكاء",
    about_rep_pdf: "أدوات تلخيص PDF",
    about_rep_search: "محرّكات البحث الذكية",
    about_rep_meditation: "تطبيقات التأمل والوعي",
    // Power
    about_power_title: "كل القوة التي تحتاجها — بضغطة واحدة",
    about_power_desc: "أربعة موديلات ذكاء اصطناعي عالمية + بحث ويب مباشر + ذاكرة طويلة المدى + تحليل عاطفي وأنماط شخصية، في تطبيق واحد يحترم خصوصيتك ويفهمك بعمق. بدون اشتراكات متعددة، بدون تعقيد.",
    // Iraqi
    iraqi_design: "تطبيق بتصميم عراقي",
  },
  en: {
    app_name: "Your Life",
    tagline_part1: "Your friend in every moment of",
    tagline_part2: "your life",
    hero_desc: "A smart companion who truly listens, supports you through sadness, celebrates your joys, and helps you organize your day and projects. Keeps your privacy and bears the name you choose.",
    cta_start: "Start your journey free",
    cta_have_account: "I have an account",
    nav_login: "Login",
    nav_register: "Sign up",
    feat_chat: "Chat", feat_journal: "Journal", feat_mood: "Mood",
    feat_goals: "Goals", feat_affirm: "Daily boost", feat_private: "Private",
    safety_title: "Your privacy & safety first",
    safety_desc: "Your information is fully protected and never shared. The companion supports you respectfully, male or female, and never provides content that promotes violence or harms you or others.",
    companion_says: "Your friend says:",
    sample_msg: "Hi 💛 I'm here for you in every moment. Whatever you feel today — joy or distress — talk to me, I'm listening.",
    sample_reply: "Thank you, I feel I'm not alone 🌿",
    welcome_back: "Welcome back 🌿",
    login_sub: "Sign in — your companion is waiting.",
    email: "Email",
    password: "Password",
    login: "Login",
    or: "or",
    facebook: "Facebook",
    twitter: "Twitter / X",
    google: "Google",
    social_soon: "Social sign-in coming soon 💛",
    auth_finalizing: "Signing you in…",
    auth_one_moment: "One moment while we open your space",
    auth_social_error: "Social sign-in failed. Please try again.",
    admin_panel: "Admin",
    login_with_google: "Continue with Google",
    no_account: "Don't have an account?",
    create_account: "Create yours",
    forgot_password: "Forgot password?",
    start_journey: "Start your journey ✨",
    register_sub: "Your account is yours alone. Your info is encrypted and never shared.",
    your_name: "Your name",
    your_email: "Your email",
    your_password: "Password (6+ chars)",
    your_age: "Your age",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Prefer not to say",
    your_country: "Country (optional)",
    your_interests: "Interests / hobbies (optional)",
    companion_label: "Your companion's name (e.g., Luna)",
    preferred_language: "Preferred language",
    privacy_note: "🔒 Privacy: your info is never shared, only used so your companion understands you better.",
    safety_note: "🛡️ The app always supports your safety and never provides harmful content.",
    create_my_account: "Create my account",
    have_account: "Have an account?",
    sign_in: "Sign in",
    reset_title: "Password recovery 🔐",
    reset_sub: "Enter your email to get a recovery code.",
    send_reset: "Send recovery code",
    back_to_login: "Back to login",
    reset_token_label: "Recovery code (copy it):",
    proceed_reset: "Continue to reset",
    reset_new_title: "Reset password",
    reset_new_sub: "Enter the recovery code and your new password.",
    reset_token_input: "Recovery code",
    new_password: "New password (6+ chars)",
    confirm_password: "Confirm password",
    update_password: "Update password",
    passwords_dont_match: "Passwords don't match",
    hello: "Hello,",
    logout: "Logout",
    your_companion: "Your companion",
    personal_companion: "your personal companion",
    tab_chat: "Chat", tab_journal: "Journal", tab_mood: "Mood",
    tab_goals: "Goals", tab_weekly: "Weekly Review",
    tab_health: "My Health",
    tab_appointments: "My Schedule",
    mood_happy: "Happy", mood_neutral: "Neutral", mood_sad: "Sad",
    mood_stressed: "Stressed", mood_motivated: "Motivated",
    chat_placeholder: "Message your companion...",
    send: "Send",
    clear: "Clear",
    confirm_clear: "Clear the whole conversation?",
    start_chat: "Start chatting with your companion... Share what you feel right now 💛",
    error_retry: "Something went wrong. Try again.",
    attach_image: "Attach image",
    take_photo: "Take photo",
    remove_image: "Remove image",
    image_caption_placeholder: "Ask about this image... (optional)",
    image_too_large: "Image too large (max 8 MB)",
    image_only: "Please select an image file only",
    record_voice: "Record voice",
    stop_recording: "Stop recording",
    recording: "Recording...",
    transcribing: "Converting voice to text...",
    voice_not_supported: "Your browser does not support voice recording",
    voice_permission_denied: "Please allow microphone access",
    play_aloud: "Play aloud",
    stop_playback: "Stop",
    voice_settings: "Voice settings",
    voice_pick: "Choose voice",
    voice_speed: "Speed",
    attach_pdf: "Attach PDF",
    pdf_only: "Please select a PDF file only",
    journal_title_label: "Your journal",
    journal_title_input: "Title (optional)",
    journal_content_input: "Write what's on your mind...",
    add_to_journal: "Add to journal",
    no_journal_yet: "Nothing written yet. Start your journal 🌸",
    untitled: "Untitled",
    log_mood_title: "Log your mood",
    mood_note_input: "Quick note (optional)",
    log: "Log",
    stats_label: "Your stats",
    entries: "entries",
    last_logs: "Recent logs",
    goals_title: "Your goals & projects",
    goal_title_input: "Goal title",
    goal_desc_input: "Short description (optional)",
    add_goal: "Add goal",
    no_goals: "Add your first goal 🎯 Your companion is with you every step.",
    weekly_title: "Weekly Review",
    weekly_loading: "Preparing your reflection...",
    weekly_top_mood: "Top mood",
    weekly_journal_count: "Journal entries",
    weekly_goals_completed: "Goals completed",
    weekly_chat_count: "Chat messages",
    weekly_active_goals: "Active goals",
    weekly_refresh: "Refresh",
    tab_memories: "Memory",
    memories_title: "What your companion remembers about you",
    memories_empty: "No memories yet. Chat more and your companion will start remembering details about you automatically 🧠",
    memories_intro: "These facts are extracted automatically from your conversations so your companion always remembers you. You can delete any or all.",
    clear_all_memories: "Clear all memories",
    confirm_clear_memories: "Clear all your companion's memories?",
    tab_insights: "Insights",
    insights_title: "Your companion's insights about you",
    insights_intro: "A smart analysis of your patterns over the last 30 days — what your companion notices about you.",
    insights_loading: "Your companion is thinking about you...",
    insights_themes: "What they notice about you",
    insights_refresh: "Refresh insights",
    starters_label: "Conversation ideas",
    starters_refresh: "New ideas",
    web_search_used: "Web search",
    tab_images: "Images",
    tab_pdf: "PDF",
    tab_voice: "Voice chat",
    download: "Download",
    confirm_delete: "Delete this?",
    // Images
    images_title: "AI Images",
    images_subtitle: "Generate new images or edit existing ones",
    img_mode_generate: "Generate from text",
    img_mode_edit: "Edit an image",
    img_upload_label: "Input image",
    img_choose_file: "Choose image",
    img_prompt_label: "Image prompt",
    img_prompt_gen_ph: "e.g. A peaceful garden at sunrise with cherry blossoms, watercolor style…",
    img_prompt_edit_ph: "e.g. Change the background to a sunset beach, keep the subject unchanged…",
    img_btn_generate: "Generate image",
    img_btn_edit: "Edit image",
    img_working: "Working…",
    img_prompt_required: "Type an image prompt first",
    img_file_required: "Pick an image to edit",
    img_too_big: "Image too large (max 8 MB)",
    img_history: "Your past images",
    // PDF
    pdf_title: "PDF Analysis",
    pdf_subtitle: "Upload a PDF and ask the AI anything about it",
    pdf_upload_label: "PDF file",
    pdf_choose_file: "Choose PDF",
    pdf_question_label: "Your question",
    pdf_question_ph: "e.g. Summarize the document, or what are the key numbers? (leave empty for a general summary)",
    pdf_analyze_btn: "Analyze file",
    pdf_working: "Reading and analyzing…",
    pdf_file_required: "Upload a PDF first",
    pdf_too_big: "File too large (max 15 MB)",
    pdf_pages: "pages",
    pdf_truncated: "⚠️ File truncated due to length; reply is based on the part read.",
    pdf_answer_label: "Analysis",
    pdf_history: "Your past analyses",
    // About section
    about_kicker: "Why «Your Life»?",
    about_title: "About the app",
    about_intro: "«Your Life» isn't just another AI chat — it's an integrated companion system that cares for your emotions, time, memories, and goals, built on the world's most powerful AI models and protected by the highest encryption standards.",
    about_goals_title: "What does the app aim for?",
    about_goals_desc: "We want to give you a digital companion that understands you deeply, supports you in every moment, protects your privacy, and organizes your life — without feeling cold or robotic.",
    about_goal_companion_title: "Always there",
    about_goal_companion_desc: "Listens to your joys and sorrows, remembers what matters so you feel truly understood.",
    about_goal_organize_title: "Organize your life",
    about_goal_organize_desc: "Goals, journals, mood tracking, weekly analysis — all in one place.",
    about_goal_growth_title: "Real personal growth",
    about_goal_growth_desc: "Smart monthly insights reveal your patterns, and daily nudges help you progress.",
    about_goal_languages_title: "In every language",
    about_goal_languages_desc: "16 supported languages — the AI replies in your language automatically.",
    about_security_title: "Security & encryption systems",
    about_security_desc: "Your data is yours alone. We use the same security standards trusted by world-class banks.",
    about_sec_aes_title: "AES-256 encryption + HTTPS/TLS 1.3",
    about_sec_aes_desc: "All your data in the database is protected with military-grade encryption, and every connection is encrypted in transit.",
    about_sec_jwt_title: "JWT authentication + Bcrypt",
    about_sec_jwt_desc: "Passwords stored with Bcrypt (irreversible), sessions secured with JWT tokens that auto-expire.",
    about_sec_isolation_title: "Strict per-user data isolation",
    about_sec_isolation_desc: "Your chats, journals, images, files — all isolated at the database level. Nobody but you sees them.",
    about_sec_privacy_title: "Absolute privacy",
    about_sec_privacy_desc: "We don't sell your data, never share it with third parties, and never use it to train any model.",
    about_engines_title: "AI systems powering the app",
    about_engines_desc: "Behind the scenes, the app runs on a curated set of the world's strongest AI models — each chosen for what it does best.",
    about_eng_claude_title: "Claude Sonnet 4.5 (Anthropic)",
    about_eng_claude_desc: "The main conversation engine — understands your emotions, remembers your details, and replies with warmth.",
    about_eng_gpt_title: "ChatGPT GPT-5.1 (OpenAI)",
    about_eng_gpt_desc: "PDF analyst — reads your documents and answers questions about them with high accuracy.",
    about_eng_gemini_title: "Gemini Nano Banana (Google)",
    about_eng_gemini_desc: "Image generation and editing — create new images or edit yours any way you like.",
    about_eng_search_title: "Live web + YouTube search",
    about_eng_search_desc: "The AI auto-searches the internet and YouTube to answer with up-to-date facts and links.",
    about_eng_memory_title: "Long-term memory",
    about_eng_memory_desc: "Smart extraction builds your profile from every chat, so your companion remembers the tiniest detail.",
    about_eng_insights_title: "Pattern analyzer",
    about_eng_insights_desc: "Analyzes your data weekly and surfaces insights about your mood, focus, and progress.",
    about_replaces_title: "Replaces dozens of apps",
    about_replaces_desc: "Instead of paying for a journal app, a mood tracker, an image editor, and an AI chatbot — get them all in one seamless experience.",
    about_rep_journal: "Journal apps",
    about_rep_mood: "Mood trackers",
    about_rep_planner: "Task & goal planners",
    about_rep_chatbot: "AI chatbots",
    about_rep_imgedit: "AI image editors",
    about_rep_pdf: "PDF summarizers",
    about_rep_search: "Smart search engines",
    about_rep_meditation: "Meditation & mindfulness apps",
    about_power_title: "All the power you need — in one tap",
    about_power_desc: "Four world-class AI models + live web search + long-term memory + emotional & pattern analysis, in one app that respects your privacy and understands you deeply. No multiple subscriptions, no complexity.",
    iraqi_design: "An Iraqi-designed app",
  },

  // ---------- Central Kurdish — Sorani (سۆرانی) ----------
  ckb: {
    app_name: "ژیانی تۆ",
    tagline_part1: "هاوڕێی تۆ لە هەموو ساتێکی",
    tagline_part2: "ژیانتدا",
    hero_desc: "هاوڕێیەکی زیرەک کە بە دڵسۆزی گوێت لێ دەگرێت، لە خەمەکانتدا پاڵپشتیت دەکات، لە دڵخۆشییەکانتدا لەگەڵتدا دڵخۆشە، و یارمەتیت دەدات بۆ ڕێکخستنی ڕۆژ و پڕۆژەکانت. پاراستنی تایبەتمەندیت و ئەو ناوەی تۆ هەڵیدەبژێریت.",
    cta_start: "گەشتەکەت بەخۆڕایی دەست پێ بکە",
    cta_have_account: "هەژمارم هەیە",
    nav_login: "چوونەژوورەوە",
    nav_register: "تۆمارکردن",
    feat_chat: "گفتوگۆ", feat_journal: "ڕۆژەڤت", feat_mood: "کەشت",
    feat_goals: "ئامانجەکانت", feat_affirm: "هانی ڕۆژانە", feat_private: "تایبەت بە تۆ",
    safety_title: "تایبەتمەندی و سەلامەتیت یەکەم",
    safety_desc: "زانیاریەکانت بە تەواوی پارێزراون و لەگەڵ کەس بەشدار ناکرێن. هاوڕێکەت بە ڕێزەوە پاڵپشتیت دەکات، نێرینە بێیت یان مێینە، و هیچ ناوەڕۆکێک پێشکەش ناکات کە تووندوتیژی پاڵپشتی بکات یان زیانت بگەیەنێت یان زیان بە کەسانی تر بگەیەنێت.",
    companion_says: "هاوڕێکەت دەڵێت:",
    sample_msg: "بەخێر بێیت 💛 من لێرەم بۆ تۆ لە هەموو ساتێکدا. هەرچییەک هەست دەکەیت ئەمڕۆ — دڵخۆشی یان نیگەرانی — قسەم لەگەڵ بکە، من گوێ دەگرم.",
    sample_reply: "سپاس، هەست دەکەم تەنیا نیم 🌿",
    welcome_back: "بەخێر بێیتەوە 🌿",
    login_sub: "بچۆ ژوورەوە — هاوڕێکەت چاوەڕێتە.",
    email: "ئیمەیڵ",
    password: "وشەی نهێنی",
    login: "چوونەژوورەوە",
    or: "یان",
    google: "گووگڵ",
    facebook: "فەیسبووک",
    twitter: "تویتەر",
    no_account: "هەژمارت نییە؟",
    create_account: "هەژمارێک دروست بکە",
    forgot_password: "وشەی نهێنیت لەبیر چووە؟",
    start_journey: "گەشتەکەت دەست پێ بکە ✨",
    register_sub: "هەژمارەکەت تەنیا بۆ تۆیە. زانیاریەکانت شفرە کراون و لەگەڵ کەس بەشدار ناکرێن.",
    your_name: "ناوت",
    your_email: "ئیمەیڵت",
    your_password: "وشەی نهێنی (٦ پیت یان زیاتر)",
    your_age: "تەمەنت",
    gender: "ڕەگەز",
    male: "نێر",
    female: "مێ",
    other: "نامەوێ دیاری بکەم",
    your_country: "وڵاتت (ئیختیاری)",
    your_interests: "حەزەکانت (ئیختیاری)",
    companion_label: "ناوی هاوڕێی زیرەکت (نموونە: نوور)",
    preferred_language: "زمانی هەڵبژێردراو",
    privacy_note: "🔒 تایبەتمەندیت پارێزراوە: زانیاریەکانت لەگەڵ کەس بەشدار ناکرێن و تەنیا بۆ ئەوە بەکار دێن کە هاوڕێکەت زیاتر تێت بگات.",
    safety_note: "🛡️ ئەپڵیکەیشنەکە هەمیشە سەلامەتیت پاڵپشتی دەکات و هیچ ناوەڕۆکێک پێشکەش ناکات کە زیانت بگەیەنێت.",
    create_my_account: "هەژمارەکەم دروست بکە",
    have_account: "هەژمارت هەیە؟",
    sign_in: "بچۆ ژوورەوە",
    send_reset: "نێردنی کۆدی گەڕاندنەوە",
    back_to_login: "گەڕانەوە بۆ چوونەژوورەوە",
    reset_title: "گەڕاندنەوەی وشەی نهێنی 🔐",
    reset_sub: "ئیمەیڵت بنوسە بۆ وەرگرتنی کۆدی گەڕاندنەوە.",
    tab_chat: "گفتوگۆ", tab_journal: "ڕۆژەڤ", tab_mood: "کەش",
    tab_goals: "ئامانج", tab_weekly: "پێداچوونەوەی هەفتانە",
    tab_health: "تەندروستی من",
    tab_appointments: "ژاوەرکانم",
    mood_happy: "دڵخۆش", mood_neutral: "ئاسایی", mood_sad: "خەمگین",
    mood_stressed: "ماندوو", mood_motivated: "هاندراو",
    chat_placeholder: "قسە لەگەڵ هاوڕێکەت بکە...",
    send: "ناردن",
    clear: "پاککردنەوە",
    confirm_clear: "هەموو گفتوگۆکە پاک بکرێتەوە؟",
    start_chat: "گفتوگۆ لەگەڵ هاوڕێکەت دەست پێ بکە... ئەوەی هەستی پێدەکەیت بەشی بکە 💛",
    error_retry: "هەڵەیەک ڕوویدا، تکایە دووبارە هەوڵ بدەرەوە.",
    attach_image: "هاوپێچکردنی وێنە",
    take_photo: "وێنە گرتن",
    remove_image: "لابردنی وێنە",
    image_caption_placeholder: "پرسیار بکە دەربارەی ئەم وێنەیە... (ئیختیاری)",
    image_too_large: "وێنەکە زۆر گەورەیە (سنوور ٨ مێگابایت)",
    image_only: "تکایە تەنیا فایلی وێنە هەڵبژێرە",
    record_voice: "تۆمارکردنی دەنگ",
    stop_recording: "وەستاندنی تۆمارکردن",
    recording: "تۆمارکردن...",
    transcribing: "گۆڕینی دەنگ بۆ نووسین...",
    voice_not_supported: "وێبگەڕەکەت تۆمارکردنی دەنگ پشتگیری ناکات",
    voice_permission_denied: "تکایە ڕێگەبدە بۆ مایکرۆفۆن",
    play_aloud: "گوێگرتن",
    stop_playback: "وەستان",
    voice_settings: "ڕێکخستنی دەنگ",
    voice_pick: "دەنگ هەڵبژێرە",
    voice_speed: "خێرایی",
    attach_pdf: "هاوپێچی PDF",
    pdf_only: "تکایە تەنیا فایلی PDF هەڵبژێرە",
    personal_companion: "هاوڕێی شەخسی تۆ",
    starters_label: "پێشنیاری گفتوگۆ",
    starters_refresh: "نوێکردنەوە",
    iraqi_design: "ئەپڵیکەیشن بە دیزاینی عێراقی",
    // ---- Extended UI translations (Sorani) ----
    hello: "سڵاو",
    logout: "دەرچوون",
    admin_panel: "بەڕێوەبردن",
    confirm_delete: "ئایا دڵنیایت لە سڕینەوە؟",
    confirm_password: "دووبارەکردنەوەی وشەی نهێنی",
    new_password: "وشەی نهێنی نوێ",
    update_password: "گۆڕینی وشەی نهێنی",
    passwords_dont_match: "وشە نهێنیەکان وەک یەکتر نین",
    proceed_reset: "بەردەوامبوون",
    reset_token_input: "کۆدی گەڕاندنەوە",
    reset_token_label: "کۆدێک کە بۆ ئیمەیڵت نێردراوە",
    reset_new_title: "وشەی نهێنی نوێ دابنێ",
    reset_new_sub: "وشەی نهێنی نوێت بنوسە بۆ هەژمارەکەت.",
    download: "داگرتن",
    untitled: "بێ ناونیشان",
    error: "هەڵە",
    your_companion: "هاوڕێی تۆ",
    auth_finalizing: "چوونەژوورەوەت ئەنجام دەدرێت...",
    auth_one_moment: "چەند ساتێک تا گەیشتنت بە شوێنی تایبەتت",
    auth_social_error: "چوونەژوورەوەی سۆشیال سەرکەوتوو نەبوو. تکایە دووبارە هەوڵ بدەرەوە.",
    // Journal
    journal_title_label: "ڕۆژەڤی تۆ",
    journal_title_input: "ناونیشان (ئیختیاری)",
    journal_content_input: "ئەوەی لە مێشکتدایە بنوسە...",
    add_to_journal: "زیادکردن بۆ ڕۆژەڤ",
    no_journal_yet: "هێشتا هیچت نەنوسیوە. ڕۆژەڤت دەست پێ بکە 🌸",
    // Mood
    log_mood_title: "کەشت تۆمار بکە",
    mood_note_input: "تێبینی کورت (ئیختیاری)",
    log: "تۆمار",
    stats_label: "ئامارەکانت",
    entries: "تۆمار",
    last_logs: "دواترین تۆمارەکان",
    // Goals
    goals_title: "ئامانج و پڕۆژەکانت",
    goal_title_input: "ناونیشانی ئامانج",
    goal_desc_input: "وەسفی کورت (ئیختیاری)",
    add_goal: "زیادکردنی ئامانج",
    no_goals: "یەکەم ئامانجت زیاد بکە 🎯",
    // Weekly
    weekly_title: "پێداچوونەوەی هەفتانە",
    weekly_loading: "ئامادەکردنی پێداچوونەوەت...",
    weekly_top_mood: "کەشی زۆرینە",
    weekly_journal_count: "ڕۆژەڤ",
    weekly_goals_completed: "ئامانجی تەواوبوو",
    weekly_chat_count: "نامەی گفتوگۆ",
    weekly_active_goals: "ئامانجی چالاک",
    weekly_refresh: "نوێکردنەوە",
    // Memories
    tab_memories: "بیرەوەری هاوڕێ",
    memories_title: "ئەوەی هاوڕێکەت لە تۆ یاد دەکات",
    memories_empty: "هێشتا بیرەوەری نییە. زۆرتر قسە بکە تا هاوڕێکەت وردەکارییەکانت یاد بکات 🧠",
    memories_intro: "ئەم زانیاریانە بە ئۆتۆماتیک لە گفتوگۆکانتانەوە دەرهێنراوە.",
    clear_all_memories: "سڕینەوەی هەموو بیرەوەرییەکان",
    confirm_clear_memories: "ئایا دەتەوێت هەموو بیرەوەرییەکان بسڕیتەوە؟",
    // Insights
    tab_insights: "تێگەیشتن دەربارەی تۆ",
    insights_title: "تێگەیشتنی هاوڕێکەت دەربارەت",
    insights_intro: "شیکاری زیرەکانە بۆ نموونەکانت لە ٣٠ ڕۆژدا.",
    insights_loading: "هاوڕێکەت دەربارەت بیر دەکاتەوە...",
    insights_themes: "ئەوەی تێبینی دەکات",
    insights_refresh: "نوێکردنەوەی تێگەیشتن",
    starters_label: "پێشنیار بۆ گفتوگۆ",
    starters_refresh: "پێشنیاری نوێ",
    web_search_used: "گەڕان لە ئینتەرنێت",
    // Images
    tab_images: "وێنە",
    tab_voice: "گفتوگۆی دەنگی",
    images_title: "وێنە دروستکردن و دەستکاری",
    images_subtitle: "وێنە نوێ دروست بکە یان دەستکاری وێنە بکە.",
    img_mode_generate: "دروستکردن",
    img_mode_edit: "دەستکاری",
    img_prompt_label: "وەسف",
    img_prompt_required: "وەسفێک بنوسە",
    img_choose_file: "هەڵبژاردنی وێنە",
    img_upload_label: "وێنە بەرز بکەرەوە",
    img_file_required: "تکایە وێنە هەڵبژێرە",
    img_too_big: "وێنە زۆر گەورەیە (سنوور ٨MB)",
    img_btn_generate: "وێنە دروست بکە",
    img_btn_edit: "وێنە دەستکاری بکە",
    img_history: "مێژووی وێنەکانت",
    img_working: "ئامادەکردن...",
    // PDF
    pdf_title: "شیکردنەوەی PDF",
    pdf_subtitle: "فایلی PDF بەرز بکەوە و پرسیار بکە.",
    pdf_upload_label: "بەرزکردنەوەی فایل",
    pdf_choose_file: "هەڵبژاردنی PDF",
    pdf_file_required: "تکایە فایلێک هەڵبژێرە",
    pdf_too_big: "فایل زۆر گەورەیە (سنوور ١٥MB)",
    pdf_question_label: "پرسیارت چییە؟ (ئیختیاری)",
    pdf_question_ph: "نموونە: کورتە بکە، یان دوای بەشێکی دیاری بگەڕێ",
    pdf_analyze_btn: "شیکردنەوە",
    pdf_working: "خوێندنەوەی فایل...",
    pdf_answer_label: "وەڵامی هاوڕێکەت",
    pdf_pages: "لاپەڕە",
    pdf_truncated: "ناوەڕۆکی فایل کرانەوە بۆ شیکردنەوە",
    pdf_history: "فایلە شیکراوەکانت",
    // About
    about_title: "دەربارەی ئەپڵیکەیشنەکە",
    about_intro: "تۆ ئەپڵیکەیشنێکی ئاسایی بەکار ناهێنیت — تۆ تاقمێکی پسپۆڕ بەدەستەوەیە لە ژێر ئامانجی یەکێتیدا: ئەمە تۆیە.",
    about_kicker: "هاوڕێی AIـی تۆ، پاڵپشتی هەستی، نوسەری ڕۆژەڤت، شیکارگەری کەشی تۆ، مامۆستای ئامانجەکانت — هەموو لە یەک شوێندا.",
    about_goals_title: "ئامانجی ئەپڵیکەیشنەکە",
    about_goals_desc: "هاوبەشی و ڕێبەری ڕۆژانە، ڕۆژەڤی ئەلیکترۆنی، چاودێریکردنی کەش، و سیستەمی ئامانج — هەموو لە ئاوێزانی AIـی پێشکەوتوو لە یەک شوێندا.",
    about_security_title: "سیستەمی پاراستن",
    about_security_desc: "زانیاریەکانت بە تەواوی بۆ تۆن. ئێمە هەمان ستانداردی پاراستنی بانکی جیهانی بەکار دێنین.",
    about_engines_title: "مۆتۆرە زیرەکەکان",
    about_engines_desc: "ئەپڵیکەیشنەکە لەسەر باشترین مۆدێلەکانی AIـی جیهان دەخوێنێت.",
    about_replaces_title: "جێگرەوەی دەیان ئەپڵیکەیشن",
    about_replaces_desc: "بۆ ڕۆژەڤ، کەش، چاودێری، نووسەری AI و چاکسازی وێنە — هەموویان لە یەک ئەپڵیکەیشندا.",
    about_power_title: "هەموو هێزی پێویست — بە یەک کرتە",
    about_power_desc: "چوار مۆدێلی AIـی جیهانی + گەڕانی زیندووی وێب + بیرەوەری درێژخایەن + شیکاری هەستی، لە یەک ئەپڵیکەیشندا.",
  },

  // ---------- Kurmanji-Badini Kurdish (کوردی بادینی) ----------
  kmr: {
    app_name: "ژیانێ تە",
    tagline_part1: "هەڤالێ تە د هەر گاڤەکا",
    tagline_part2: "ژیانا تەدا",
    hero_desc: "هەڤالەکێ زیرەک کو ب دڵسۆزی گوهداریا تە دکەت، د خەمێن تەدا پشتگیریا تە دکەت، د دڵخۆشیێن تەدا لگەل تە دڵخۆش دبیت، و ئالیکاریا تە دکەت بۆ رێکخستنا رۆژا تە و پرۆژێن تە. تایبەتمەندیا تە دپارێزیت و ئەو ناڤێ تو دیار دکی.",
    cta_start: "سەفەرا خۆ ب بەلاش دەست پێ بکە",
    cta_have_account: "هەژمارا من هەیە",
    nav_login: "چوونا ژوور",
    nav_register: "تۆمارکرن",
    feat_chat: "ئاخفتن", feat_journal: "رۆژنامێ تە", feat_mood: "کێفا تە",
    feat_goals: "ئارمانجێن تە", feat_affirm: "هاندانا رۆژانە", feat_private: "تایبەت ب تە",
    safety_title: "تایبەتمەندی و سەلامەتیا تە یەکێ",
    safety_desc: "زانیاریێن تە ب تەواوی پارێزراون و لگەل کەسێ پارڤە ناکرن. هەڤال ب رێزدارانە پشتگیریا تە دکەت، نێر بی یان مێ، و هیچ ناڤەرۆکێ پێشکێش ناکەت کو تووندوتیژی یا تە یان یا کەسێن دی پشتگیری بکەت.",
    companion_says: "هەڤالێ تە دبێژیت:",
    sample_msg: "بەخێرهاتی 💛 ئەز ل ڤێرە م بۆ تە د هەر گاڤەکێدا. هەرچی هەست دکی ئەڤرۆ — دڵخۆشی یان خەم — لگەل من بئاخڤە، ئەز گوهدارا تەمە.",
    sample_reply: "سپاس، هەست دکم ئەز ب تنێ نینم 🌿",
    welcome_back: "بەخێرهاتی 🌿",
    login_sub: "بچۆ ژوور — هەڤالێ تە ل چاڤەرێیێ یە.",
    email: "ئیمەیل",
    password: "پەیڤا نهێنی",
    login: "چوون",
    or: "یان",
    google: "گووگل",
    facebook: "فەیسبووک",
    twitter: "تویتەر",
    no_account: "هەژمارا تە نینە؟",
    create_account: "هەژمارەکێ دروست بکە",
    forgot_password: "پەیڤا نهێنی ژبیر کریە؟",
    start_journey: "سەفەرا خۆ دەست پێ بکە ✨",
    register_sub: "هەژمارا تە تنێ یا تە یە. زانیاریێن تە شفرە کرین و لگەل کەسێ پارڤە ناکرن.",
    your_name: "ناڤێ تە",
    your_email: "ئیمەیلا تە",
    your_password: "پەیڤا نهێنی (٦ تیپ یان زێدەتر)",
    your_age: "تەمەنێ تە",
    gender: "رەگەز",
    male: "نێر",
    female: "مێ",
    other: "ناخوازم دیار بکم",
    your_country: "وەلاتێ تە (ئیختیاری)",
    your_interests: "حەزێن تە (ئیختیاری)",
    companion_label: "ناڤێ هەڤالێ تە یێ زیرەک (نموونە: نوور)",
    preferred_language: "زمانێ هەلبژارتی",
    privacy_note: "🔒 تایبەتمەندیا تە پارێزراو: زانیاریێن تە لگەل کەسێ پارڤە ناکرن.",
    safety_note: "🛡️ ئەپلیکەیشن هەمیشە سەلامەتیا تە پشتگیری دکەت.",
    create_my_account: "هەژمارا من دروست بکە",
    have_account: "هەژمارا تە هەیە؟",
    sign_in: "بچۆ ژوور",
    send_reset: "هنارتنا کۆدێ ڤەگەراندنێ",
    back_to_login: "ڤەگەرین بۆ چوون",
    reset_title: "ڤەگەراندنا پەیڤا نهێنی 🔐",
    reset_sub: "ئیمەیلا خۆ بنڤێسە بۆ وەرگرتنا کۆدێ ڤەگەراندنێ.",
    tab_chat: "ئاخفتن", tab_journal: "رۆژنامە", tab_mood: "کێف",
    tab_goals: "ئارمانج", tab_weekly: "بەرگیریا هەفتیانە",
    tab_health: "تەندروستیا من",
    tab_appointments: "دەمێن من",
    mood_happy: "دڵخۆش", mood_neutral: "ئاسایی", mood_sad: "خەمگین",
    mood_stressed: "ماندی", mood_motivated: "هاندایی",
    chat_placeholder: "لگەل هەڤالێ خۆ بئاخڤە...",
    send: "هنارتن",
    clear: "پاککرن",
    confirm_clear: "هەمی ئاخفتن پاک بکە؟",
    start_chat: "ئاخفتنا خۆ لگەل هەڤالێ خۆ دەست پێ بکە... ئەوا هەست پێ دکی پارڤە بکە 💛",
    error_retry: "هەلەیەک رویدا، تکایە دیسا هەول بدە.",
    attach_image: "هاوپێچکرنا وێنە",
    take_photo: "وێنە گرتن",
    remove_image: "لابرنا وێنە",
    image_caption_placeholder: "پرسیارا خۆ ل دەربارا وێنێ بکە... (ئیختیاری)",
    image_too_large: "وێنە زۆر مەزن (سنوور ٨ مێگابایت)",
    image_only: "تکایە تنێ فایلا وێنە هەلبژێرە",
    record_voice: "تۆمارکرنا دەنگی",
    stop_recording: "راوەستاندنا تۆمارکرنێ",
    recording: "تۆمارکرن...",
    transcribing: "گوهۆڕینا دەنگی بۆ نڤیسین...",
    voice_not_supported: "وێبگەرا تە تۆمارکرنا دەنگی پشتگیری ناکەت",
    voice_permission_denied: "تکایە دەستوور بدە بۆ مایکرۆفۆن",
    play_aloud: "گوهداری",
    stop_playback: "راوەستان",
    voice_settings: "رێکخستنێن دەنگی",
    voice_pick: "دەنگەکێ هەلبژێرە",
    voice_speed: "خێرایی",
    attach_pdf: "هاوپێچا PDF",
    pdf_only: "تکایە تنێ فایلا PDF هەلبژێرە",
    personal_companion: "هەڤالێ تە یێ کەسایەتی",
    starters_label: "پێشنیار",
    starters_refresh: "نوێکرن",
    iraqi_design: "ئەپلیکەیشن ب دیزاینێ عێراقی",
    // ---- Extended UI translations (Badini) ----
    hello: "سلاڤ",
    logout: "دەرکەتن",
    admin_panel: "بەرێڤەبرن",
    confirm_delete: "تو دلنیا یی ژ ژێبرنێ؟",
    confirm_password: "دووبارەکرنا پەیڤا نهێنی",
    new_password: "پەیڤا نهێنیا نوو",
    update_password: "گوهۆڕینا پەیڤا نهێنی",
    passwords_dont_match: "پەیڤێن نهێنی وەک ێک نینن",
    proceed_reset: "بەردەوامبوون",
    reset_token_input: "کۆدێ ڤەگەراندنێ",
    reset_token_label: "کۆدا کو بۆ ئیمەیلا تە هاتیە هنارتن",
    reset_new_title: "پەیڤا نهێنیا نوو دانە",
    reset_new_sub: "پەیڤا نهێنیا نوو ژبۆ هەژمارا خۆ بنڤێسە.",
    download: "داگرتن",
    untitled: "بێ ناڤونیشان",
    error: "هەلە",
    your_companion: "هەڤالێ تە",
    auth_finalizing: "چوونا تە ل ژوور یا د بەردەوامیێدا یە...",
    auth_one_moment: "چەند دەقیقەیەک هەتا ئەم تە بگەهینین جهێ تە",
    auth_social_error: "چوونا سۆشیال سەرکەفتی نەبوو. دیسا هەول بدە.",
    journal_title_label: "رۆژنامە یا تە",
    journal_title_input: "ناڤونیشان (ئیختیاری)",
    journal_content_input: "ئەوا د هزرا تەدا بنڤێسە...",
    add_to_journal: "زێدەکرن بۆ رۆژنامێ",
    no_journal_yet: "هێشتا هیچ نەنڤێسایە. دەست پێ بکە 🌸",
    log_mood_title: "کێفا خۆ تۆمار بکە",
    mood_note_input: "تێبینی کورت (ئیختیاری)",
    log: "تۆمار",
    stats_label: "ئامارێن تە",
    entries: "تۆمار",
    last_logs: "دواهی تۆمار",
    goals_title: "ئارمانج و پرۆژێن تە",
    goal_title_input: "ناڤونیشانێ ئارمانجی",
    goal_desc_input: "وەسفێ کورت (ئیختیاری)",
    add_goal: "زێدەکرنا ئارمانجی",
    no_goals: "ئارمانجا خۆ یا یەکێ زێدە بکە 🎯",
    weekly_title: "بەرگیریا هەفتیانە",
    weekly_loading: "بەرگیریا تە یا ئامادە دبیت...",
    weekly_top_mood: "کێفا زۆرینە",
    weekly_journal_count: "رۆژنامە",
    weekly_goals_completed: "ئارمانجێن تەواوبوویی",
    weekly_chat_count: "نامێن ئاخفتنێ",
    weekly_active_goals: "ئارمانجێن چالاک",
    weekly_refresh: "نوێکرن",
    tab_memories: "بیرڤەری یا هەڤال",
    memories_title: "ئەو تشتێن هەڤالێ تە ل سەر تە بیر دکەن",
    memories_empty: "هێشتا بیرڤەری نینە. زێدەتر ئاخفتنێ بکە 🧠",
    memories_intro: "ئەڤ زانیاری ب ئۆتۆماتیکی ژ ئاخفتنا وەردگرین.",
    clear_all_memories: "پاککرنا هەمی بیرڤەرییا",
    confirm_clear_memories: "ئایا دخوازی هەمی بیرڤەرییا پاک بکی؟",
    tab_insights: "تێگەهشتن لسەر تە",
    insights_title: "تێگەهشتنا هەڤالێ تە لسەر تە",
    insights_intro: "شیکارا زیرەک یا نمونێن تە د ٣٠ رۆژەکێدا.",
    insights_loading: "هەڤالێ تە ل سەر تە هزر دکەت...",
    insights_themes: "ئەوا تێبینی دکەت",
    insights_refresh: "نوێکرنا تێگەهشتنا",
    starters_label: "پێشنیار",
    starters_refresh: "پێشنیارێن نوو",
    web_search_used: "گەران ل ئینتەرنێتێ",
    tab_images: "وێنە",
    tab_voice: "ئاخفتنا دەنگی",
    images_title: "وێنە دروستکرن و دەستکاری",
    images_subtitle: "وێنە یا نوو دروست بکە یان دەستکاری بکە.",
    img_mode_generate: "دروستکرن",
    img_mode_edit: "دەستکاری",
    img_prompt_label: "وەسف",
    img_prompt_required: "وەسفەکێ بنڤێسە",
    img_choose_file: "هەلبژاردنا وێنە",
    img_upload_label: "بەرزکرنا وێنە",
    img_file_required: "تکایە وێنە هەلبژێرە",
    img_too_big: "وێنە زۆر مەزن (سنوور ٨MB)",
    img_btn_generate: "وێنە دروست بکە",
    img_btn_edit: "وێنە دەستکاری بکە",
    img_history: "دیرۆکا وێنێن تە",
    img_working: "د ئامادەکرنێدا...",
    pdf_title: "شیکرنا PDF",
    pdf_subtitle: "فایلێ PDF بەرز بکە و پرسیارا خۆ بکە.",
    pdf_upload_label: "بەرزکرنا فایلی",
    pdf_choose_file: "هەلبژاردنا PDF",
    pdf_file_required: "تکایە فایلەکێ هەلبژێرە",
    pdf_too_big: "فایل زۆر مەزن (سنوور ١٥MB)",
    pdf_question_label: "پرسیارا تە چ ە؟ (ئیختیاری)",
    pdf_question_ph: "نموونە: کورتە بکە، یان لسەر بەشێ دیار بپرسە",
    pdf_analyze_btn: "شیکرن",
    pdf_working: "د خواندنا فایلیدا...",
    pdf_answer_label: "بەرسڤا هەڤالێ تە",
    pdf_pages: "پەڕە",
    pdf_truncated: "ناڤەرۆکێ فایلی هاتە کورتکرن",
    pdf_history: "فایلێن تە یێن شیکرین",
    about_title: "دەربارا ئەپلیکەیشنێ",
    about_intro: "تو ئەپلیکەیشنەکا ئاسایی بکار ناینی — تو تیمەکا پسپۆڕ یا د خزمەتا تە دایە: ئەڤە تۆ یە.",
    about_kicker: "هەڤالێ AIـیێ تە، پشتگیریا هەستی، نڤێسەرا رۆژنامێ، شیکارا کێفێ، مامۆستایێ ئارمانجا — هەمی د یەک جهیدا.",
    about_goals_title: "ئارمانجێن ئەپلیکەیشنێ",
    about_goals_desc: "هاوبەشی و رێبەریا رۆژانە، رۆژنامەی ئەلکترۆنی، چاودێریا کێفێ، و سیستەما ئارمانجا — هەمی ل ژێر AIـیێ پێشکەفتی.",
    about_security_title: "سیستەما پاراستنێ",
    about_security_desc: "زانیاریێن تە ب تەواوی یێن تە نە. هەمان ستانداردا پاراستنا بانکێن جیهانی بکار دینین.",
    about_engines_title: "مۆتۆرێن زیرەک",
    about_engines_desc: "ئەپلیکەیشن ل سەر باشترین مۆدێلێن AIـیێ جیهانی دخوینیت.",
    about_replaces_title: "جێگرێ دەیان ئەپلیکەیشنا",
    about_replaces_desc: "بۆ رۆژنامە، کێف، چاودێری، نڤێسەرێ AI و چاکسازیا وێنە — هەمی د یەک ئەپلیکەیشنیدا.",
    about_power_title: "هەمی هێزا پێدڤی — ب یەک کلیک",
    about_power_desc: "چوار مۆدێلێن AIـیێ جیهانی + گەرانا زیندیا وێبی + بیرڤەریا درێژخایەن + شیکاریا هەستی، د یەک ئەپلیکەیشنیدا.",
  },
};

// For other languages, fall back to English UI; the AI itself responds in the user's chosen language
export function t(lang, key) {
  return T[lang]?.[key] ?? T.en[key] ?? key;
}
